module.exports = __webpack_public_path__ + "static/media/ios-flask.1efc53c7.svg";